import { Box } from "@mui/material";
import type { FC } from "react";
import { NEUTRAL } from "../../../theme/tokens";
import { RoleGroupOrJobSelector } from "../../UIToolkit/molecules/RoleGroupOrJobSelector";
import { ShiftTypeFilterChips, type ShiftTypeFilterValue } from "../../UIToolkit/molecules/ShiftTypeFilterChips";
import { RequestOriginFilter } from "../RequestOrigin/RequestOriginFilter";
import type { OriginFilterControl } from "../RequestOrigin/requestOriginMeta";

type Props = {
	selectedRoleGroups: string[];
	onSelectedRoleGroupsChanged: (selected: string[]) => void;
	selectedJobIds: string[];
	onSelectedJobIdsChanged: (selected: string[]) => void;
	selectedShiftType: ShiftTypeFilterValue;
	onSelectedShiftTypeChanged: (next: ShiftTypeFilterValue) => void;
	/** `null` where the department does not get request origins — no Origin filter is shown. */
	originFilter: OriginFilterControl | null;
};

export const RequestsTabFilters: FC<Props> = ({
	selectedRoleGroups,
	onSelectedRoleGroupsChanged,
	selectedJobIds,
	onSelectedJobIdsChanged,
	selectedShiftType,
	onSelectedShiftTypeChanged,
	originFilter,
}) => (
	<Box
		sx={{
			display: "flex",
			flexDirection: "column",
			gap: 1.5,
			p: 1.5,
			mb: 1,
			mx: 1,
			mt: 1,
			flexShrink: 0,
			backgroundColor: NEUTRAL[50],
			borderRadius: 2,
			border: `1px solid ${NEUTRAL[200]}`,
		}}
	>
		<RoleGroupOrJobSelector
			selectedRoleGroups={selectedRoleGroups}
			onSelectedRoleGroupsChanged={onSelectedRoleGroupsChanged}
			selectedJobIds={selectedJobIds}
			onSelectedJobsChanged={onSelectedJobIdsChanged}
		/>
		{originFilter === null ? (
			<ShiftTypeFilterChips value={selectedShiftType} onChange={onSelectedShiftTypeChanged} dataTestId="requests-shift-type-filter" />
		) : (
			<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
				<Box sx={{ flex: 1, minWidth: 0 }}>
					<ShiftTypeFilterChips value={selectedShiftType} onChange={onSelectedShiftTypeChanged} dataTestId="requests-shift-type-filter" />
				</Box>
				<RequestOriginFilter control={originFilter} />
			</Box>
		)}
	</Box>
);
